<template>
	<div id="map-container" class="map-container">
		<div id="container" :style="{ height: mapHeight + 'px' }"></div>

		<!-- 搜索面板 -->
		<div class="search-panel">
			<div class="search-form">
				<h3>行驶轨迹与路线规划</h3>

				<div class="input_cell">
					<div class="fontSize14 label col-333">
						运单号:
					</div>
					<div class="input_box">
						<el-input type="text" placeholder="请输入" v-model="lorId"></el-input>
					</div>
				</div>
				<!-- 操作按钮 -->
				<div class="form-actions">
					<button @click="querylorIdLine" :disabled="loading" class="btn btn-primary">
						{{ loading ? "搜索中..." : "下载运单轨迹" }}
					</button>
				</div>

				<div class="info-box">
					<div class="info-row">
						<label>车辆名称：</label>
						<span id="chepai" v-text="plateNo || '-'"></span>
					</div>
					<div class="operation-row">
						<label>选择时间：</label>
						<div class="buttonGroup">
							<span class="btn" id="today" @click="today()">今天</span>
							<span class="btn" id="beforeday" @click="beforeday()">前一天</span>
							<span class="btn" id="afterday" @click="afterday()">后一天</span>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							开始时间:
						</div>
						<div class="input_box">
							<el-date-picker style="width: 100%;" v-model="startDate" type="datetime" :clearable="false"
								placeholder="请选择开始时间" @change="getstartDate">
							</el-date-picker>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							结束时间:
						</div>
						<div class="input_box">
							<el-date-picker style="width: 100%;" v-model="endDate" type="datetime" :clearable="false"
								placeholder="请选择结束时间" @change="getendDate">
							</el-date-picker>
						</div>
					</div>
				</div>
				<!-- 操作按钮 -->
				<div class="form-actions">
					<button @click="queryVehiceLine" :disabled="loading" class="btn btn-primary">
						{{ loading ? "搜索中..." : "下载明细轨迹" }}
					</button>
				</div>
				<!-- 车辆动画控制进度条 -->
				<div class="form-actions">
					<div class="progressDiv_playBtn">
						<!-- //0->未开始  1->行驶中  2->暂停 -->
						<img v-if="carPalyStayus == 0" @click="startAnimation([])"
							src="@/assets/images/icon-play-button-blue.png" />
						<img v-if="carPalyStayus == 1" @click="pauseAnimation"
							src="@/assets/images/icon-stop-red-big.png" />
						<img v-if="carPalyStayus == 2" @click="resumeAnimation"
							src="@/assets/images/icon-play-button-blue.png" />
					</div>
					<div class="progressDiv_sliderDiv" style="width: 250px;">
						<!--进度条-->
						{{sliderVal + '%'}}
						<input type="range" v-model="sliderVal" @input="sliderChange" min="0" max="100" step="1"
							style="width: 160px;" />
						<!-- <el-slider v-model="sliderVal" :step="1" @change="sliderChange"
							:show-tooltip="false"></el-slider> -->
					</div>
					<div class="progressDiv_speedDiv" style="width: 80px;">
						<el-select v-model="speedCount" @change="speedCountChange($event)" placeholder="倍速选择"
							:clearable="false">
							<el-option v-for="(item,index) in speedCountArr" :label="item.name" :value="item.value"
								:key="index" />
						</el-select>
					</div>
					<!-- <div class="progressDiv_timeDiv">
						{{times}}
					</div> -->
				</div>

				<!-- <div class="form-group">
					<label>起点:</label>
					<input v-model="startPoint" type="text" placeholder="请输入起点（如：北京市地震局）" class="form-input" />
				</div>
				<div class="form-group">
					<label>终点:</label>
					<input v-model="endPoint" type="text" placeholder="请输入终点（如：亦庄文化园地铁站）" class="form-input" />
				</div>
				<div class="form-group">
					<label>途径点:
						<span class="waypoint-count">({{ waypoints.length }}/15)</span></label>
					<div class="waypoints-container">
						<div v-for="(waypoint, index) in waypoints" :key="index" class="waypoint-item">
							<input v-model="waypoints[index]" type="text" :placeholder="`途径点${index + 1}`"
								class="form-input waypoint-input" />
							<button @click="removeWaypoint(index)" class="btn btn-remove">
								删除
							</button>
						</div>
					</div>
					<button @click="addWaypoint" :disabled="waypoints.length >= 15" class="btn btn-add">
						{{ waypoints.length >= 15 ? "已达上限" : "添加途径点" }}
					</button>
				</div>
				<div class="form-actions">
					<button @click="performSearch" :disabled="loading" class="btn btn-primary">
						{{ loading ? "搜索中..." : "开始搜索" }}
					</button>
					<button @click="clearAll" class="btn btn-secondary">清空</button>
				</div> -->
			</div>

			<div class='input-card'>
				<div class="input-item">
					<input type="checkbox" v-model="isTrackChecked" @change="toggleTrack" />实际行驶轨迹<div class='color'
						style='background-color:#243290'></div>
				</div>

				<div class="input-item">
					<input type="checkbox" v-model="isRoadChecked" @change="toggleRoad" />地图路线规划<div class='color'
						style='background-color:#1bac2e'></div>
				</div>

			</div>
		</div>

		<!-- 结果面板 -->
		<div id="my-panel" class="result-panel"></div>

		<div :class="[
		        'detail',
		        'card',
		        {'closed': !showContent},
		        {'center': !showContentcenter}
		    ]">
			<div class="title">
				<div class="title-name">
					路线规划结果
				</div>
				<div class="collapse-btn">
					<ElButton size="small" @click="toggleContent">
						<i class="layui-icon"
							:class="[showContent ? 'iconfont fontSize18 icon-yuocecaidan-yincang' :'iconfont fontSize18 icon-zuocecaidan-yincang']"
							style="font-size: 18px; color: #707070"></i>
					</ElButton>
				</div>
			</div>

			<div class="content" v-if="showContent">
				<div class="info-list" v-if="infoArray && infoArray.length > 0">
					<div class="info" v-for="info in infoArray" :key="info.title">
						<p class="info-title">{{info.title}}</p>
						<p class="info-value">{{info.value}}</p>
					</div>
					<!-- <div class="info" v-for="info in weatherArr">
						<p class="info-title">{{info.weatherNo}}</p>
					</div> -->
				</div>


				<!-- 备注 -->
				<!-- <div class="note markdown" :style="`max-height: ${height}px`" v-if="contentHtml" v-html="contentHtml" /> -->
				<div class="note markdown" :style="`max-height: ${height}px`" v-if="weatherArr.length>0">
					<h3>途经地天气信息</h3>
					<ol v-for="info in weatherArr">
						<li>{{info.weatherNo}}</li>
					</ol>
				</div>


				<!-- 底部按钮 -->
				<div class="button-center">
					<slot name="footer" />
				</div>
			</div>
		</div>

		<text-tips ref="textTips"></text-tips>
		<div class="bgBlock" v-show="isDataLoading === true">
			<div class="load">
				<img src="@/assets/images/load.gif" alt="" />
				<el-progress :text-inside="true" :stroke-width="16" style="width: 200px; margin-top: 15px"
					:percentage="formatProgressPercentage"
					v-show="showLoadingPercentage == true && searchDayCount > 1"></el-progress>
			</div>
		</div>

		<el-dialog title="更新站点坐标" v-model="isAudit" width="30%" center>
			<div class="mar-bot-20"><span style="color: red">*</span>选择站点，更新坐标：{{updatelng}},{{updatelat}}</div>
			<div style="width: 100%; height: 80px">
				<el-select v-model="lorWhid" placeholder="请选择" @change="siteLoadChange">
					<el-option v-for="(item, index) in siteList" :key="index" :label="item.whName" :value="item.whId">
						<span style="float: left">{{ item.whName }}</span>
						<span style="
						          float: right;
						          color: var(--el-text-color-secondary);
						          font-size: 13px;
						        ">
							{{ item.whType }}
						</span>
					</el-option>
				</el-select>
			</div>
			<div class="btn_warp">
				<div class="btn-outline1" @click="updateSitesubmit(0)">取消</div>
				<div class="btn-outline2" @click="updateSitesubmit(1)">确定</div>
			</div>
		</el-dialog>


	</div>
</template>


<script>
	import {
		computed,
		defineComponent,
		reactive,
		toRefs,
		ref,
		nextTick,
		onMounted,
		onUnmounted,
		getCurrentInstance,
	} from "vue";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	import {
		parseTime,
		formatDateString,
		formatDatetime,
	} from "@/libs/tools";
	import {
		getShowIcon,
		getACCStatus,
		getCarStatus,
		formatMileage,
		getUrlParam,
		isSupportCanvas,
		timeDeltaCount,
		mtimeDeltaCount,
	} from "@/libs/mapUtils";
	import AMapLoader from "@amap/amap-jsapi-loader";
	import {
		throwStatement
	} from "@babel/types";
	import {
		dataTool
	} from "echarts";
	import $ from 'jquery';
	import axios from "axios";

	export default defineComponent({
		components: {},
		name: "orderTrack",

		setup() {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			const startDate = ref();
			const endDate = ref();

			//高德地图实例
			let map = null;
			//驾车路径规划服务实例
			let driving = null;

			let dragRoute = null;

			let contextMenuPositon = null;
			let mouseTool = null;

			// 响应式数据
			//起点
			const startPoint = ref();
			//终点
			const endPoint = ref();
			//途径点数组（最多15个）
			const waypoints = ref([]);
			//搜索结果数据
			const searchResult = ref(null);
			//搜索状态标识
			const loading = ref(false);

			// 跟踪天气请求以便清理
			const weatherRequests = ref([]);
			const isComponentMounted = ref(true);

			const formatProgressPercentage = computed(() => {
				if (data.progressPercentage < 0) {
					return 0;
				} else if (data.progressPercentage >= 0 && data.progressPercentage <= 100) {
					return parseFloat((data.progressPercentage * 100) / 100);
				} else if (data.progressPercentage > 100) {
					return 100;
				}
			});

			const maxSpeed = computed(() => {
				var maxSpeed = 0,
					speedArray = data.speedArr;

				speedArray.forEach(function(item) {
					if (parseInt(item) > maxSpeed) {
						maxSpeed = parseInt(item);
					}
				})

				return maxSpeed;
			});

			const searchDayCount = computed(() => {
				var startTime = startDate.value,
					endTime = endDate.value;

				if (startTime && endTime) {
					return Math.floor(Math.floor(Math.floor(((new Date(endTime.replace(/-/g, "/"))
						.getTime() / 1000) - (new Date(startTime.replace(/-/g,
							"/"))
						.getTime() / 1000)) / 60) / 60) / 24) + 1;
				} else {
					return 0;
				}
			});

			const searchDayList = computed(() => {
				var startTime = startDate.value,
					endTime = endDate.value,
					searchDayList = [];
				var startDateTemp = startTime.split(' ')[0];

				if (searchDayCount.value > 1) {
					for (var i = 0; i < searchDayCount.value; i++) {
						var currentDate = new Date(new Date(startDateTemp).getTime() + (i * 24 *
							60 * 60 *
							1000));
						var formatCurrDate = currentDate.getFullYear() + '-' +
							((currentDate.getMonth() + 1) < 10 ? ('0' + (currentDate.getMonth() +
								1)) : (
								currentDate.getMonth() + 1)) + '-' +
							(currentDate.getDate() < 10 ? ('0' + currentDate.getDate()) :
								currentDate
								.getDate());

						if (i == 0) {
							searchDayList.push({
								startTime: startTime,
								endTime: formatCurrDate + ' 23:59:59'
							})
						} else if (i == searchDayCount.value - 1) {
							searchDayList.push({
								startTime: formatCurrDate + ' 00:00:00',
								endTime: endTime
							})
						} else {
							searchDayList.push({
								startTime: formatCurrDate + ' 00:00:00',
								endTime: formatCurrDate + ' 23:59:59'
							})
						}
					}
				} else {
					searchDayList.push({
						startTime: startTime,
						endTime: endTime
					})
				}

				return searchDayList;
			});

			const data = reactive({
				showContent: true,
				showContentcenter: true,
				infoArray: [],
				screenWidth: document.documentElement.clientWidth,
				screenHeight: document.documentElement.clientHeight,
				tableId: "roleManagementTable",
				dayType: "n",
				mapHeight: 400,
				page: 1,
				pageSize: 10,
				searchWord: "",
				totalCount: 0,
				tableData: [],
				tableHeight: 0,
				orgId: "",
				orgList: [],
				maplist: [],
				// map: null,
				carMarker: null,
				startPointMarker: null,
				endPointMarker: null,
				pathSimplifierIns: null,
				pathNavigator: null,
				polyline: null,
				passedPolyline: null,
				circle: null,
				lorstartTime: "",
				lorendTime: "",
				value1: [],
				markers: [],
				isShow: true,
				newArr: [],
				orderList: [],
				radius: null,
				odrGatherCount: "",
				mapItemList: [],
				positionData: null,
				iconType: 1,
				checktype: '',
				lorLoadName: '',
				lorLoadLnglat: '',
				lorlEndName: '',
				lorlEndLnglat: '',
				lorId: getUrlParam('lorId') || '',
				plateNo: getUrlParam('plateNo') || '',
				vehicleID: getUrlParam('vehicleID') || '',
				vehicleIMEI: '',
				mileage: 0,
				stopTime: 3,
				trackType: 2, // 查询轨迹类型(0:多天行驶轨迹 1:多天明细轨迹 2:单天行驶轨迹 3:单天明细轨迹)
				range: '',
				stopList: [],
				cacheTrack: [],
				showLoadingPercentage: false,
				progressPercentage: 0,
				track: Object.freeze([]),
				lineArr: Object.freeze([]),
				newLineArr: Object.freeze([]),
				speedArr: Object.freeze([]),
				timeArr: Object.freeze([]),
				playSpeed: 1000,
				passLength: 0,
				passPercentage: 0,
				currentTrajectoryIndex: -1,
				siteList: [],
				lorWhid: null, //站点ID
				selectedwhType: '',
				selectedwhName: '',
				updatelng: '',
				updatelat: '',
				isTrackChecked: true,
				isRoadChecked: true,

				circlesList: [], //圆形数组
				areaList: [], //区域数组
				areaOrderList: [],
				isShowArea: true,
				index: 0,
				minPoints: null,
				areaAllOrder: [],
				odrCount: 0,
				selectedRows: [], // 用于存储选中的行数据数组。
				canSendInstruction: false,
				canUpdateVehicle: false,
				tabType: 'all',
				infoWindow: null,
				infoWindow2: null,
				countdownSeconds: 60,
				countdownLimitSeconds: 60,
				hiddenFlag: true,
				showTrackDetail: false,
				isPlaying: false,
				isDataLoading: false,
				stopSumTime: 0,
				driveSumTime: 0,
				sumTime: 0,
				thermody: [],
				contentHtml: '',
				weatherArr: [],
				isAudit: false,

				showOperationTools: true, // 是否展示全部地图工具
				address: '', // 地址搜索关键字

				searchAddress: false, // 是否处于搜索地址状态
				getRuleDistance: false, // 是否处于测距状态
				getMeasureArea: false, // 是否处于测量面积状态
				showSatelliteLayer: false, // 是否显示卫星地图
				showTrafficLayer: false, // 是否显示交通地图

				carPalyStayus: 0, //0->未开始  1->行驶中  2->暂停
				sliderVal: 0, //进度条位置
				speedCount: 1, //播放倍速
				speedCountArr: [{
						name: '0.5x',
						value: 0.5
					},
					{
						name: '1x',
						value: 1
					},
					{
						name: '1.5x',
						value: 1.5
					},
					{
						name: '2x',
						value: 2
					},
					{
						name: '3x',
						value: 3
					},
					{
						name: '4x',
						value: 4
					}
				],
				isSpeedCountChange: false, //改变播放倍速
				isSliderValChange: false, //改变进度条位置
				progval: 0, //播放轨迹点位置
				progvalLength: 0,
				initSpeed: 1000,
				currentTime: '',
				currentAddress: '',
				currentSpeed: 0,
			});

			onMounted(() => {
				nextTick(() => {
					var offsetHeight = document.querySelector("#map-container").offsetHeight;
					if (offsetHeight <= 0) {
						return false;
					}
					data.mapHeight = document.querySelector(" #map-container").offsetHeight;

					// document.title = '轨迹回放_' + data.plateNo;
					data.range = $('.info-box').find('input[type=range]')

					var date = new Date();
					startDate.value = formatDatetime(date.getFullYear() + '-' + (date
						.getMonth() +
						1) + '-' + date.getDate() + ' ' + '00:00:00');
					endDate.value = formatDatetime(date.getFullYear() + '-' + (date
							.getMonth() +
							1) + '-' + date.getDate() + ' ' +
						date.getHours() + ':' + date.getMinutes() + ':00');

					initMap();


				});

			});

			onUnmounted(() => {
				// 设置标志以防止新操作
				isComponentMounted.value = false

				// 取消任何待处理的天气请求
				weatherRequests.value.forEach(request => {
					if (request && request.cancel) {
						request.cancel()
					}
				})
				weatherRequests.value = []

				map?.destroy();
			});

			//初始化地图
			const initMap = () => {

				window._AMapSecurityConfig = {
					securityJsCode: "「你申请的安全密钥」",
				};
				AMapLoader.load({
						key: "e43a295f15ed06c429ff79a20f5331f0", // 申请好的Web端开发者Key，首次调用 load 时必填
						version: "2.0",
						plugins: ["AMap.Scale", "AMap.MouseTool"],
					})
					.then((AMap) => {
						map = new AMap.Map("container", {
							zoom: 10,
							center: [116.397428, 39.90923],
							viewMode: "2D",
						});

						// 添加工具条控件
						AMap.plugin('AMap.Scale', function() {
							var Scale = new AMap.Scale(); // 使用AMap.ToolBar插件
							map.addControl(Scale);
						});
						AMap.plugin('AMap.ToolBar', function() {
							var toolBar = new AMap.ToolBar({
								// position: {
								// 	top: '110px',
								// 	right: '40px'
								// }
							}); // 使用AMap.ToolBar插件
							map.addControl(toolBar);
						});
						// AMap.plugin('AMap.ControlBar', function() {
						// 	var ControlBar = new AMap.ControlBar({
						// 		position: {
						// 			top: '10px',
						// 			right: '10px',
						// 		}
						// 	}); // 使用AMap.ToolBar插件
						// 	map.addControl(ControlBar);
						// });
						// AMap.plugin('AMap.HawkEye', function() {
						// 	var HawkEye = new AMap.HawkEye(); // 使用AMap.ToolBar插件
						// 	map.addControl(HawkEye);
						// });

						AMap.plugin("AMap.Driving", function() {
							driving = new AMap.Driving({
								policy: 0, // 速度优先策略
								map: map, // 指定将路线规划方案绘制到对应的 AMap.Map 对象上
								panel: "my-panel", //指定将结构化的路线详情数据显示的对应的 DOM 上，传入值需是 DOM 的 ID
							});
						});

						map.plugin("AMap.DragRoute", function() {

						});

						AMap.plugin("AMap.MoveAnimation", function() {

						});

						data.infoWindow = new AMap.InfoWindow({
							offset: new AMap.Pixel(5, -30),
							zIndex: 6,
						});

						mouseTool = new AMap.MouseTool(map);
						initContextMenu();

						// 监听地图加载完成事件
						map.on('complete', () => {
							console.log('地图加载完成');
							// 在这里执行地图加载完成后的操作，如添加标记、设置事件监听等
							if (data.lorId !== '') {
								querylorIdLine();
							} else if (data.vehicleID !== '') {
								querylorIdvehicle();
							}
						});

					})
					.catch((e) => {
						console.log(e);
					});
			};

			const initContextMenu = () => {
				const contextMenu = new AMap.ContextMenu();
				contextMenu.addItem('放大', function() {
					map.zoomIn();
					contextMenu.close();
				}, 0);
				contextMenu.addItem('缩小', function() {
					map.zoomOut();
					contextMenu.close();
				}, 1);
				contextMenu.addItem('开始测距', function() {
					mouseTool.rule();
					contextMenu.close();
				}, 2);
				contextMenu.addItem('结束测距', function() {
					mouseTool.close();
					contextMenu.close();
				}, 3);
				contextMenu.addItem("更新此处为装卸点", function(e) {
					mouseTool.close();
					// var marker = new AMap.Marker({
					// 	map: map,
					// 	position: contextMenuPositon //基点位置
					// });
					data.lorWhid = null;
					data.selectedwhType = '';
					data.selectedwhName = '';
					data.updatelng = '';
					data.updatelat = '';
					data.updatelng = contextMenuPositon.lng;
					data.updatelat = contextMenuPositon.lat;
					contextMenu.close();
					data.isAudit = true;
				}, 4);

				map.on('rightclick', (e) => {
					contextMenu.open(map, e.lnglat);
					contextMenuPositon = e.lnglat;
				});

			};

			const updateSitesubmit = async (status) => {
				if (status == 0) {
					data.isAudit = false;
					return;
				}

				if (data.lorWhid == undefined && data.lorWhid == null && data.lorWhid == '') {
					proxy.$message.error("请先选择站点！");
					return;
				}

				if (data.updatelng == "") {
					proxy.$message.error("经纬度错误，不能更新！");
					return;
				}
				if (data.updatelat == "") {
					proxy.$message.error("经纬度错误，不能更新！");
					return;
				}

				let params = {
					whId: data.lorWhid,
					whLnglat: data.updatelng + "," + data.updatelat
				}

				const r = await proxy.$http.post(apiObj.siteUpdate, params)
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					proxy.$message.success(r.msg || r.respMsg);
					data.isAudit = false;
					
					if (data.selectedwhType == '装货点') {
						data.lorLoadLnglat = data.updatelng + "," + data.updatelat;
					} else if (data.selectedwhType == '卸货点') {
						data.lorlEndLnglat = data.updatelng + "," + data.updatelat;
					}

					initdragRoute();
				} else {
					proxy.$message.error(r.msg || r.respMsg);
				}
			};

			// 处理重复点位
			const dealRepeatArr = (tempArr) => {
				for (let i = 0; i < tempArr.length; i++) {
					for (let j = i + 1; j < tempArr.length; j++) {
						if (tempArr[i].longitude == tempArr[j].longitude && tempArr[i].latitude ==
							tempArr[j]
							.latitude) {
							tempArr.splice(j, 1)
							j--
						}
					}
				}
				return tempArr
			};

			const querylorIdLine = async () => {
				let params = {
					lorId: data.lorId,
				};
				const r = await proxy.$http.get(apiObj.ordDetail, params);
				if (r.respCode == 0 || r.respCode == "0000") {
					data.lorLoadName = r.orderInfo.lorLoadName;
					data.lorLoadLnglat = r.orderInfo.lorLoadLnglat;
					data.lorlEndName = r.orderInfo.unloadList[0].lorlEndName;
					data.lorlEndLnglat = r.orderInfo.unloadList[0].lorlEndLnglat;
					data.siteList = [];
					data.siteList.push({
						whName: r.orderInfo.lorLoadName,
						whId: r.orderInfo.lorLoadWhid,
						whType: '装货点'
					});
					data.siteList.push({
						whName: r.orderInfo.unloadList[0].lorlEndName,
						whId: r.orderInfo.unloadList[0].lorlEndWhid,
						whType: '卸货点'
					});

					if (data.lorLoadLnglat !== undefined && data.lorLoadLnglat !== null && data
						.lorLoadLnglat !== '' && data.lorLoadLnglat !== ',undefined' && data
						.lorlEndLnglat !== undefined && data
						.lorlEndLnglat !== null && data
						.lorlEndLnglat !== '' && data.lorlEndLnglat !== ',undefined') {
						data.checktype = 'lorId';
						searchLine();
					} else {
						proxy.$message.error("运单装卸货点坐标位置有误！");
						return;
					}
				} else {
					proxy.$message.error(r.respMsg);
				}
			};

			const queryVehiceLine = () => {
				data.checktype = 'vehicle';
				searchLine();
			};

			const searchLine = () => {
				//停止播放
				if (data.carMarker) {
					data.carMarker.stopMove();
					data.carPalyStayus = 0;
					data.sliderVal = 0;
					data.progval = 0;
					data.progvalLength = 0;
					data.isSpeedCountChange = false;
					data.isSliderValChange = false;
				}

				if (data.checktype == 'lorId') {
					if (data.lorId == undefined || data.lorId == null || data.lorId == '') {
						proxy.$message.error("请先填写运单号然后再查询轨迹！");
						return;
					}
				}

				if (data.checktype == 'vehicle') {
					if (data.plateNo == undefined || data.plateNo == null || data.plateNo == '') {
						proxy.$message.error("请先填写车辆然后再查询轨迹！");
						return;
					}

					if (startDate.value > endDate.value) {
						proxy.$message.error("开始时间不能大于结束时间！");
						return;
					}

					if (data.trackType == 2 && Math.floor((new Date(endDate.value.replace(/-/g, "/")) -
							new Date(startDate.value.replace(/-/g, "/"))) / 1000 / 60 / 60 / 24) >
						30) {
						proxy.$message.error("只能查询开始时间和结束时间相隔三十天内的行驶轨迹数据！");
						return;
					}

					if (data.trackType == 3 &&
						Math.floor((new Date(endDate.value.replace(/-/g, "/")) - new Date(startDate
							.value
							.replace(/-/g,
								"/"))) / 1000 / 60 / 60 / 24) > 2) {
						proxy.$message.error("只能查询开始时间和结束时间相隔两天内的明细轨迹数据！");
						return;
					}
				}


				/* ----------------------------------- 重置数据 ----------------------------------- */
				data.cacheTrack = [];
				data.progressPercentage = 0;

				// if (document.getElementById('scroller')) {
				//     document.getElementById('scroller').scrollTop = 0;
				// }
				// that.currentTrajectoryIndex = -1;
				data.range.val(0);
				data.range.css('background-size', '0% 100%');


				map.clearMap();
				data.track = [];
				data.newLineArr = [];
				data.lineArr = [];
				data.speedArr = [];
				data.timeArr = [];
				data.stopSumTime = 0;
				data.driveSumTime = 0;
				data.sumTime = 0;
				data.mileage = 0;


				if (data.startPointMarker !== null && data.startPointMarker !== undefined && data
					.startPointMarker !== '') {
					data.startPointMarker.setMap(null);
					data.startPointMarker = null;
				}

				if (data.endPointMarker !== null && data.endPointMarker !== undefined && data
					.endPointMarker !== '') {
					data.endPointMarker.setMap(null);
					data.endPointMarker = null;
				}

				if (data.carMarker !== null && data.carMarker !== undefined && data
					.carMarker !== '') {
					data.carMarker.setMap(null);
					data.carMarker = null;
				}

				if (data.stopList.length > 0) {
					data.stopList.forEach(function(item, index) {
						if (item != null && item != undefined && item != '') {
							item.setMap(null);
							item = null;
						}
					})
					data.stopList = [];
				}

				if (data.pathSimplifierIns !== null && data.pathSimplifierIns !== undefined && data
					.pathSimplifierIns !== '') {
					data.pathSimplifierIns.setData([]);
					data.pathSimplifierIns = null;
				}

				if (data.pathNavigator !== null && data.pathNavigator !== undefined && data
					.pathNavigator !== '') {
					data.pathNavigator.destroy();
					data.pathNavigator = null;
				}

				if (data.circle !== null && data.circle !== undefined && data.circle !== '') {
					data.circle.setMap(null);
					data.circle = null;
				}
				/* ------------------------------------------------------------------------------- */

				data.isDataLoading = true;
				data.showLoadingPercentage = true;
				getTrackData(0);
			};

			const getTrackData = async (index) => {
				var urlStr = '';
				let params = null;
				if (data.checktype == 'lorId') {
					params = {
						lorId: data.lorId,
						type: 0,
					};
					urlStr = apiObj.getOrderTraffic;
				}

				if (data.checktype == 'vehicle') {
					params = {
						vehId: data.vehicleID,
						// startTime: startDate.value,
						// endTime: endDate.value,
						startTime: searchDayList.value[index].startTime,
						endTime: searchDayList.value[index].endTime,
						type: parseInt(data.trackType),
					};
					urlStr = apiObj.getVehTraffic;
				}

				const r = await proxy.$http.postFormData(urlStr, params);
				console.log(r);
				if (r.respCode == "0000") {
					data.tableData = r.list;

					r.list.forEach(function(item) {
						data.cacheTrack.push(item)
					})

					data.stopSumTime += r.stopSumTime;
					data.driveSumTime += r.driveSumTime;
					data.sumTime += r.sumTime;

					if (data.checktype == 'lorId') {
						data.lorstartTime = r.startTime;
						data.lorendTime = r.endTime;
						data.plateNo = r.vehNo;
						data.vehicleID = r.vehId;
						data.vehicleIMEI = r.terImei;
						startDate.value = r.startTime;
						endDate.value = r.endTime;
					}

					if (data.checktype == 'vehicle') {
						data.vehicleIMEI = r.terminalId;
					}

					data.progressPercentage = parseFloat(((index + 1) / searchDayCount.value) *
							100)
						.toFixed(2);
					nextTick(() => {
						calculateLoadingStatus();
					});

				} else {
					data.isDataLoading = false;
					alert('查询轨迹信息失败！');
				}


				function calculateLoadingStatus() {
					if (data.checktype == 'vehicle' && index + 1 !== searchDayCount.value) {
						getTrackData(index + 1)
					} else {
						//that.previousDevice = that.device;
						//that.initHeatMap(that.thermody);//热力图

						if (data.cacheTrack !== null && data.cacheTrack !== undefined) {
							var minStopTime = parseInt(data.stopTime) * 60;
							var sumMileage = 0,
								alarmDetail = '';

							if (data.cacheTrack.length > 0) {
								data.cacheTrack.forEach(function(v1, i1) {
									sumMileage += parseInt(v1.dis);
									alarmDetail = '';

									if (v1.wname !== '[]' && v1.sname !== '[]') {
										alarmDetail = v1.wname.substr(1, v1.wname.length -
												1) +
											',' +
											v1.sname.substr(1, v1.sname.length - 1);
									} else if (v1.wname === '[]' && v1.sname !== '[]') {
										alarmDetail = v1.sname.substr(1, v1.sname.length -
											1);
									} else if (v1.wname !== '[]' && v1.sname === '[]') {
										alarmDetail = v1.wname.substr(1, v1.wname.length -
											1);
									}

									v1.id = i1;
									v1.alarmDetail = alarmDetail;
									v1.sumMileage = sumMileage;
									data.newLineArr[i1] = [v1.lng, v1.lat];
									data.lineArr[i1] = [v1.lng, v1.lat];
									data.speedArr[i1] = v1.sp;
									data.timeArr[i1] = v1.serT;


									// that.$set(v1, 'id', i1);
									// that.$set(v1, 'alarmDetail', alarmDetail);
									// that.$set(v1, 'sumMileage', sumMileage);


									// that.$set(that.newLineArr, i1, [v1.lng, v1.lat]);
									// that.$set(that.lineArr, i1, [v1.lng, v1.lat]);
									// that.$set(that.speedArr, i1, v1.sp);
									// that.$set(that.timeArr, i1, v1.serT);

									data.lineArr.push([v1.lng, v1.lat]);

									if (parseInt(i1) == 0) {
										data.carMarker = new AMap.Marker({
											map: map,
											position: [v1.lng, v1.lat],
											icon: "https://a.amap.com/jsapi_demos/static/demo-center-v2/car.png",
											offset: new AMap.Pixel(-13, -26),
										});


										data.startPointMarker = new AMap.Marker({
											position: [v1.lng, v1.lat],
											map: map,
											icon: new AMap.Icon({
												size: new AMap.Size(30,
													30), //图标大小
												image: require(
													'@/assets/images/hstart.png'
												),
												imageOffset: new AMap
													.Pixel(0, 0)
											})
										})

										data.startPointMarker.on('click', function(e) {
											var i = "";
											AMap.plugin('AMap.Geocoder',
												function() {
													var geocoder = new AMap
														.Geocoder({
															batch: true
														});
													geocoder.getAddress(e
														.target
														.getPosition(),
														function(status,
															result) {
															i = result
																.regeocode
																.formattedAddress;
															data.infoWindow
																.setContent(
																	"<div class='markerContent' style='width: 200px;border-radius: 10px;padding:10px 0;background: #ffffff'>" +
																	"   <p style='font-size: 13px'>开始点</p>" +
																	"   <p style='font-size: 13px'>时间：" +
																	formatDatetime(
																		v1
																		.serT
																	) +
																	"</p>" +
																	"   <p style='font-size: 13px'>地址：" +
																	i +
																	"</p>" +
																	"</div>"
																);
															data.infoWindow
																.open(
																	map, e
																	.target
																	.getPosition()
																);
														});
												});
										});

									} else if (parseInt(i1) == data.cacheTrack.length -
										1) {
										data.endPointMarker = new AMap.Marker({
											position: [v1.lng, v1.lat],
											map: map,
											icon: new AMap.Icon({
												size: new AMap.Size(30,
													30), //图标大小
												image: require(
													'@/assets/images/hend.png'
												),
												imageOffset: new AMap
													.Pixel(0, 0)
											})
										});

										data.endPointMarker.on('click', function(e) {
											var i = "";
											AMap.plugin('AMap.Geocoder',
												function() {
													var geocoder = new AMap
														.Geocoder({
															batch: true
														});
													geocoder.getAddress(e
														.target
														.getPosition(),
														function(status,
															result) {
															i = result
																.regeocode
																.formattedAddress;
															data.infoWindow
																.setContent(
																	"<div class='markerContent' style='width: 200px;border-radius: 10px;padding:10px 0;background: #ffffff'>" +
																	"   <p style='font-size: 13px'>结束点</p>" +
																	"   <p style='font-size: 13px'>时间：" +
																	formatDatetime(
																		v1
																		.serT
																	) +
																	"</p>" +
																	"   <p style='font-size: 13px'>地址：" +
																	i +
																	"</p>" +
																	"</div>"
																);
															data.infoWindow
																.open(
																	map, e
																	.target
																	.getPosition()
																);
														});
												});
										});
									}


									if (v1.stopT != null) {
										if (Math.abs(v1.stopT) > (parseInt(data.stopTime) *
												60)) {
											var marker = new AMap.Marker({
												position: [v1.lng, v1.lat],
												map: map,
												icon: new AMap.Icon({
													size: new AMap.Size(30,
														30), //图标大小
													image: require(
														'@/assets/images/hp.png'
													),
													imageOffset: new AMap
														.Pixel(0,
															0)
												}),
												label: {
													content: mtimeDeltaCount(v1
														.stopT), //设置文本标注内容
													direction: 'bottom' //设置文本标注方位
												},
											})


											/*marker.content = "<div class='markerContent' style='width: 200px;border-radius: 10px;padding:10px 0;background: #ffffff'>" +
			                                    "   <p style='font-size: 13px'>时间：" + formatDate(v1.serT) + "</p>" +
			                                    "   <p style='font-size: 13px'>" + (that.iconType <= 3 ? '停车点' : '静止点') + "(" + that.timeDeltaCount(v1.stopT) + ")</p>" +
			                                    "</div>"
			
			                                 AMap.event.addListener(marker, 'mouseover', function (e) {
			                                    infoWindow.setContent(e.target.content);
			                                    infoWindow.open(map, e.target.getPosition());
			                                });
			                                AMap.event.addListener(marker, 'mouseout', function (e) {
			                                    infoWindow.close();
			                                });*/

											marker.on('click', function(e) {
												var i = "";
												AMap.plugin('AMap.Geocoder',
													function() {
														var geocoder = new AMap
															.Geocoder({
																batch: true
															});
														geocoder.getAddress(e
															.target
															.getPosition(),
															function(
																status,
																result) {
																i = result
																	.regeocode
																	.formattedAddress;
																data.infoWindow
																	.setContent(
																		"<div class='markerContent' style='width: 200px;border-radius: 10px;padding:10px 0;background: #ffffff'>" +
																		"   <p style='font-size: 13px'>时间：" +
																		formatDatetime(
																			v1
																			.serT
																		) +
																		"</p>" +
																		"   <p style='font-size: 13px'>" +
																		(data
																			.iconType <=
																			3 ?
																			'停车点' :
																			'静止点'
																		) +
																		"(" +
																		timeDeltaCount(
																			v1
																			.stopT
																		) +
																		")</p>" +
																		"   <p style='font-size: 13px'>地址：" +
																		i +
																		"</p>" +
																		"</div>"
																	);
																data.infoWindow
																	.open(
																		map,
																		e
																		.target
																		.getPosition()
																	);
															});
													});
											});


											data.stopList.push(marker)
										}
									}
								});
								data.mileage = sumMileage;

								data.infoWindow.close();
								data.infoWindow2 = new AMap.InfoWindow({
									offset: new AMap.Pixel(5, -10),
									zIndex: 6,
								});


								initPathNavigator();
							} else {
								alert("暂无轨迹信息！");
							}
						} else {
							alert("暂无轨迹信息！");
						}
						data.track = data.cacheTrack;


						setTimeout(function() {
							data.isDataLoading = false;
							data.showLoadingPercentage = false;
						}, (searchDayCount.value > 1 ? 0.75 * 1000 : 0.1 * 1000))
					}
				}
			};

			const initPathNavigator = () => {

				// 绘制轨迹
				data.polyline = new AMap.Polyline({
					map: map,
					path: data.lineArr,
					showDir: true,
					strokeColor: "#243290", //线颜色
					strokeOpacity: 1, //线透明度
					strokeWeight: 6, //线宽
					// strokeStyle: "solid"  //线样式
				});

				data.passedPolyline = new AMap.Polyline({
					map: map,
					strokeColor: "#AF5", //线颜色
					strokeWeight: 6, //线宽
				});

				// 创建路线规划
				initdragRoute();


				// // 创建拖拽路线插件实例
				// route = new AMap.DragRoute(map, [], {
				// 	startMarkerOptions: {
				// 		icon: 'https://webapi.amap.com/theme/v1.3/markers/n/start.png'
				// 	},
				// 	endMarkerOptions: {
				// 		icon: 'https://webapi.amap.com/theme/v1.3/markers/n/end.png'
				// 	},
				// 	midMarkerOptions: {
				// 		icon: 'https://webapi.amap.com/theme/v1.3/markers/n/mid.png'
				// 	},
				// 	lineOptions: {
				// 		strokeColor: '#1a6dff',
				// 		strokeWeight: 6,
				// 		strokeOpacity: 0.8
				// 	}
				// });

				// // 监听路线规划完成事件
				// route.on('complete', function(data) {
				// 	if (data && data.routes && data.routes.length > 0) {
				// 		const route = data.routes[0];
				// 		const distance = (route.distance / 1000).toFixed(1);
				// 		const time = Math.ceil(route.time / 60);

				// 		totalDistanceEl.textContent = `${distance} 公里`;
				// 		totalTimeEl.textContent = `${time} 分钟`;
				// 		pointCountEl.textContent = `${dragRoute.getWayPoints().length} 个`;

				// 		statusEl.textContent = `路线规划完成：总距离 ${distance} 公里，预计时间 ${time} 分钟`;
				// 		statusEl.className = 'status ready';
				// 	}
				// });

				// // 监听路线规划错误事件
				// route.on('error', function() {
				// 	statusEl.textContent = '路线规划失败，请调整路径点位置';
				// 	statusEl.className = 'status error';
				// });

				// data.Routepath = [];
				// data.Routepath.push([data.lineArr[0][0], data.lineArr[0][1]]);
				// data.Routepath.push([data.lineArr[data.lineArr.length - 1][0], data.lineArr[data.lineArr
				// 	.length - 1][1]]);
				// // // path.push([data.lineArr[0][0], data.lineArr[0][1]]);
				// // // path.push([data.lineArr[data.lineArr.length - 1][0], data.lineArr[data.lineArr.length - 1][1]]);
				// dragRoute = new AMap.DragRoute(map, data.Routepath, AMap.DrivingPolicy.LEAST_FEE); //构造拖拽导航类
				// dragRoute.search(); //查询导航路径并开启拖拽导航

				// 设置默认起点和终点（北京市中心区域）
				// const startPoint = data.lineArr[0]; // 天安门
				// const endPoint = data.lineArr[data.lineArr.length - 1]; // 王府井
				// dragRoute.search(startPoint, endPoint, function(status, result) {
				// 	if (status === 'complete') {
				// 		searchResult.value = result;
				// 		console.log("路径规划成功", result);
				// 	} else {
				// 		console.log("路径规划失败", result);
				// 		alert("路径规划失败，请检查输入的地点是否正确");
				// 	}
				// });

				// 执行搜索
				// driving.search(new AMap.LngLat(data.lineArr[0][0], data.lineArr[0][1]), new AMap.LngLat(data
				// 	.lineArr[data.lineArr.length - 1][0], data.lineArr[data.lineArr.length - 1][1]), (
				// 	status, result) => {
				// 	loading.value = false;
				// 	if (status === "complete") {
				// 		searchResult.value = result;
				// 		console.log("路径规划成功", result);
				// 	} else {
				// 		console.log("路径规划失败", result);
				// 		alert("路径规划失败，请检查输入的地点是否正确");
				// 	}
				// });

				// 调整地图视野以显示整个轨迹
				map.setFitView();

			};

			const initdragRoute = () => {
				// 切换线路之前如果存在路线，销毁已存在的路线
				if (dragRoute) {
					dragRoute.destroy()
					dragRoute = null
				}

				// 创建 DragRoute 实例
				var path = [];
				if (data.checktype == 'lorId') {
					let BLnglat = data.lorLoadLnglat.split(',');
					let ELnglat = data.lorlEndLnglat.split(',');
					path.push([BLnglat[0], BLnglat[1]]);
					path.push([ELnglat[0], ELnglat[1]]);
				} else {
					path.push([data.lineArr[0][0], data.lineArr[0][1]]);
					path.push([data.lineArr[data.lineArr.length - 1][0], data.lineArr[data.lineArr.length -
						1][
						1
					]]);
				}

				dragRoute = new AMap.DragRoute(map, path, {
					policy: 0, // 策略：0-最短时间，1-最短距离，2-避开高速
					showTraffic: true, // 显示实时路况
					// startMarkerOptions: {
					//     offset: new AMap.Pixel(-13, -43),
					//     icon: new AMap.Icon({ // 设置途经点的图标
					//         size: new AMap.Size(26, 43),
					//         image: 'data:image/png;base64,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',
					//         // imageOffset: new AMap.Pixel(0,0), // 图片的偏移量，在大图中取小图的时候有用
					//         imageSize: new AMap.Size(26, 43) // 指定图标的大小，可以压缩图片

					//     }),
					// },
					// endMarkerOptions: {
					//     offset: new AMap.Pixel(-13, -43),
					//     icon: new AMap.Icon({ // 设置途经点的图标
					//         size: new AMap.Size(26, 43),
					//         image: 'data:image/png;base64,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',
					//         // imageOffset: new AMap.Pixel(0,0), // 图片的偏移量，在大图中取小图的时候有用
					//         imageSize: new AMap.Size(26, 43) // 指定图标的大小，可以压缩图片

					//     }),
					// },
				});

				// 监听路线规划完成事件
				dragRoute.on('complete', (result) => {
					console.log('路线规划完成', result);
					updateRouteInfo(result);

					//showMessage('路线规划完成！可以拖拽路线上的点重新规划', 'success');
				});

				// 开始搜索路线
				dragRoute.search();
			};




			//开始回放
			const startAnimation = (arr) => {
				if (!data.carMarker || !data.lineArr.length) return

				const carDuration = data.initSpeed / data.speedCount
				if (data.sliderVal > 0 && data.carPalyStayus == 0) { //未播放的情况下，直接从指定位置开始播放
					reDrawPolyline(0); //倍数变化之后，需要从新绘制线
				} else { //从头开始播放
					data.carPalyStayus = 1; //0->未开始  1->行驶中  2->暂停
					arr = data.lineArr;
					data.carMarker.moveAlong(arr, carDuration);
				}
				// carDuration：移动速度，单位：米/秒
				data.carMarker.on('moving', function(e) {
					data.passedPolyline.setPath(e.passedPath);
					map.setCenter(e.target.getPosition(),
						true)
					var len = e.passedPath.length;
					data.progval = (len - 1) + data.progvalLength;
					// data.sliderVal = Math.round(len * 100 / data
					// 	.track.length);
					// 更新进度条
					const progress = Math.round((data.progval / data.lineArr.length) * 100)
					data.sliderVal = Math.min(100, Math.max(0, progress))
					// 更新当前信息
					updateCurrentInfo();
				});
				// 监听移动结束事件
				data.carMarker.on('movealong', () => {
					data.carPalyStayus = 0
					data.sliderVal = 100
				})
			};
			//暂停回放
			const pauseAnimation = () => {
				if (data.carMarker) {
					data.carMarker.pauseMove();
					data.carPalyStayus = 2; //0->未开始  1->行驶中  2->暂停
				}
			};
			//继续回放
			const resumeAnimation = () => {
				if (!data.carMarker) return

				//如果点击了暂停，并切换了倍数，从新绘制
				if ((data.carPalyStayus == 2 && data.isSpeedCountChange) || (data.carPalyStayus == 2 &&
						data
						.isSliderValChange)) {
					data.isSpeedCountChange = false;
					data.isSliderValChange = false;
					reDrawPolyline(2); //倍数变化之后，需要从新绘制线
				}
				data.carMarker.resumeMove();
				data.carPalyStayus = 1; //0->未开始  1->行驶中  2->暂停
			};
			//倍速选择
			const speedCountChange = (e) => {
				// carPalyStayus //0->未开始  1->行驶中  2->暂停
				// 如果正在行驶中点击倍数
				if (data.carPalyStayus == 1) {
					data.carMarker.pauseMove(); // 先暂停车
					reDrawPolyline(1); //倍数变化之后，需要从新绘制线
				} else if (data.carPalyStayus == 2) {
					data.isSpeedCountChange = true;
				}
			};
			//进度条拖动
			const sliderChange = () => {
				if (!data.lineArr.length) return

				//手动拖动进度条过程中触发：移动车辆，定位车辆回放位置
				//计算拖动进度条后车辆对应轨迹新的索引值
				var getIndex = Math.round(data.lineArr.length * data.sliderVal / 100);
				var currentIndex = 0
				if (getIndex > 0) {
					currentIndex = getIndex - 1;
				}
				var vehicleLocation = data.lineArr[currentIndex];
				if (data.carMarker) {
					data.carMarker.setPosition(new AMap.LngLat(vehicleLocation[0], vehicleLocation[
						1]));
				}

				if (currentIndex == 0) {
					data.progval = 1; //处理重新绘制线路时 that.progval-1 找不到值报错
				} else {
					data.progval = currentIndex;
				}
				data.progvalLength = data.progval;

				// carPalyStayus //0->未开始  1->行驶中  2->暂停
				if (data.carPalyStayus == 1) {
					data.carMarker.pauseMove(); // 先暂停车
					reDrawPolyline(1); //倍数变化之后，需要从新绘制线
				} else if (data.carPalyStayus == 2) {
					data.isSliderValChange = true;
				}

				// 更新当前信息
				updateCurrentInfo(currentIndex)
			};

			const reDrawPolyline = (type) => {
				if (!data.lineArr.length) return

				let currentIndex = 0

				if (type === 0) {
					currentIndex = Math.round(data.lineArr.length * data.sliderVal / 100)
					currentIndex = currentIndex > 0 ? currentIndex - 1 : 0
				} else if (type === 1) {
					currentIndex = Math.round(data.lineArr.length * data.sliderVal / 100)
					currentIndex = currentIndex > 0 ? currentIndex - 1 : 0
				} else if (type === 2) {
					// 从暂停位置继续
					currentIndex = data.progval
				}

				const remainingPath = data.lineArr.slice(currentIndex)

				if (remainingPath.length > 0) {
					const carDuration = data.initSpeed / data.speedCount

					data.carPalyStayus = 1
					data.progvalLength = currentIndex

					data.carMarker.moveAlong(remainingPath, carDuration)
				}

			};

			// 更新路线信息
			const updateRouteInfo = (result) => {
				// 路线规划完成后，返回的路线数据：设置距离、行驶时间
				let lineData = result.data.routes[0]
				let distance = (lineData.distance / 1000).toFixed(1) // m -> km
				let time = (lineData.time / 60).toFixed() // second -> min

				fetchWeatherFromRoute(lineData.steps);

				data.infoArray = [];
				if (data.checktype == 'lorId') {
					data.infoArray.push({
						title: '查询类型',
						value: '运单轨迹'
					});
					data.infoArray.push({
						title: '运单号',
						value: data.lorId
					});
					data.infoArray.push({
						title: '装货点',
						value: data.lorLoadName
					});
					data.infoArray.push({
						title: '卸货点',
						value: data.lorlEndName
					});
					data.infoArray.push({
						title: '车辆',
						value: data.plateNo
					});
					data.infoArray.push({
						title: '设备ID',
						value: data.vehicleIMEI
					});
					data.infoArray.push({
						title: '起始时间',
						value: data.lorstartTime
					});
					data.infoArray.push({
						title: '结束时间',
						value: data.lorendTime
					});
					data.infoArray.push({
						title: '最高时速',
						value: maxSpeed.value
					});
					data.infoArray.push({
						title: '平均时速',
						value: parseFloat((data.mileage / 1000) / (data.sumTime / 60 / 60))
							.toFixed(2)
					});
					data.infoArray.push({
						title: '停车时长',
						value: timeDeltaCount(data.stopSumTime)
					});
					data.infoArray.push({
						title: '行车时长',
						value: timeDeltaCount(data.driveSumTime)
					});
					data.infoArray.push({
						title: '行驶里程',
						value: formatMileage(data.mileage)
					});
				}

				if (data.checktype == 'vehicle') {
					data.infoArray.push({
						title: '查询类型',
						value: '行驶轨迹'
					});
					data.infoArray.push({
						title: '车辆',
						value: data.plateNo
					});
					data.infoArray.push({
						title: '设备ID',
						value: data.vehicleIMEI
					});
					data.infoArray.push({
						title: '起始时间',
						value: startDate.value
					});
					data.infoArray.push({
						title: '结束时间',
						value: endDate.value
					});
					data.infoArray.push({
						title: '最高时速',
						value: maxSpeed.value
					});
					data.infoArray.push({
						title: '平均时速',
						value: parseFloat((data.mileage / 1000) / (data.sumTime / 60 / 60))
							.toFixed(2)
					});
					data.infoArray.push({
						title: '停车时长',
						value: timeDeltaCount(data.stopSumTime)
					});
					data.infoArray.push({
						title: '行车时长',
						value: timeDeltaCount(data.driveSumTime)
					});
					data.infoArray.push({
						title: '行驶里程',
						value: formatMileage(data.mileage)
					});
				}
				data.infoArray.push({
					title: '路线策略',
					value: lineData.policy
				})
				data.infoArray.push({
					title: '预算距离/时间',
					value: `${formatMileage(lineData.distance)} / ${timeDeltaCount(lineData.time)}`
				})

				// document.getElementById('routeInfo').style.display = 'block';

				// if (result.routes && result.routes.length > 0) {
				// 	const route = result.routes[0];
				// 	document.getElementById('distance').textContent = (route.distance / 1000).toFixed(1) +
				// 	'公里';
				// 	document.getElementById('duration').textContent = formatTime(route.time);
				// 	document.getElementById('strategy').textContent = '最短时间';
				// }
			};

			// 更新当前信息
			const updateCurrentInfo = (index) => {
				if (!data.track.length) return

				const currentIndex = index || Math.round(data.lineArr.length * data.sliderVal / 100)
				const datatemp = data.track[Math.min(currentIndex, data.track.length - 1)]

				if (datatemp) {
					data.infoWindow2.setContent("<div  style='padding: 10px 10px;'>" +
						"<div class='right' style='width:100%;float:right;margin: 0 6%;font-size:12px'>" +
						"<p style='line-height:20px'>名称：" + data.plateNo + "</p>" +
						"<p style='line-height:20px'>速度：" + datatemp.sp + "km/h</p>" +
						"<p style='line-height:20px'>时间：" + formatDatetime(datatemp.serT) +
						"</p>" +
						"</div>" +
						"</div>");
					data.infoWindow2.open(map, [datatemp.lng, datatemp.lat]);
				}

			};

			// 执行搜索
			const performSearch = () => {
				if (!startPoint.value || !endPoint.value) {
					alert("请输入起点和终点");
					return;
				}

				loading.value = true;

				// 构建搜索参数：起点 + 途径点 + 终点
				const searchParams = [{
					keyword: startPoint.value
				}];

				// 添加有效的途径点到数组中间
				const validWaypoints = waypoints.value.filter((point) => point.trim());
				validWaypoints.forEach((point) => {
					searchParams.push({
						keyword: point
					});
				});

				// 添加终点
				searchParams.push({
					keyword: endPoint.value
				});

				// 执行搜索
				driving.search(searchParams, (status, result) => {
					loading.value = false;
					if (status === "complete") {
						searchResult.value = result;
						console.log("路径规划成功", result);
					} else {
						console.log("路径规划失败", result);
						alert("路径规划失败，请检查输入的地点是否正确");
					}
				});
			};

			// 添加途径点
			const addWaypoint = () => {
				if (waypoints.value.length >= 15) {
					alert("最多只能添加15个途径点");
					return;
				}
				waypoints.value.push("");
			};

			// 删除途径点
			const removeWaypoint = (index) => {
				waypoints.value.splice(index, 1);
			};

			// 清空所有输入
			const clearAll = () => {
				startPoint.value = "";
				endPoint.value = "";
				waypoints.value = [];
				driving?.clear();
				dragRoute.clear();
			};

			const getstartDate = (ev) => {
				startDate.value = parseTime(ev, "{y}-{m}-{d} {h}:{i}:{s}");
				console.log(startDate.value);
			};

			const getendDate = (ev) => {
				endDate.value = parseTime(ev, "{y}-{m}-{d} {h}:{i}:{s}");
				console.log(endDate.value);
			};

			const toggleTrack = (ev) => {
				console.log('Checkbox changed:', event.target.checked);
				data.isTrackChecked = ev.target.checked;
				// 这里你可以处理更多的逻辑，例如根据checked的值进行操作
				if (event.target.checked) {
					data.polyline.show();
				} else {
					data.polyline.hide();
				}
			};

			const toggleRoad = (ev) => {
				console.log('Checkbox changed:', ev.target.checked);
				data.isRoadChecked = ev.target.checked;
				// 这里你可以处理更多的逻辑，例如根据checked的值进行操作
				if (event.target.checked) {
					// 创建路线规划
					initdragRoute();

				} else {
					if (dragRoute) {
						dragRoute.destroy()
						dragRoute = null
					}
				}
			};

			const toggleContent = (ev) => {
				data.showContent = !data.showContent
				showContentcenter = !data.showContentcenter
			};

			const GetDateStr = (AddDayCount) => {
				var dd = new Date();
				dd.setDate(dd.getDate() + AddDayCount);
				return dd.getFullYear() + "-" + (dd.getMonth() + 1) + "-" + dd.getDate();
			};

			const today = () => {
				if (data.isPlaying === false) {
					startDate.value = formatDatetime(GetDateStr(0) + ' ' + '00:00:00');
					endDate.value = formatDatetime(GetDateStr(0) + ' ' + '23:59:59');
					data.checktype = 'vehicle';
					searchLine();
				}
			};

			const beforeday = () => {
				var beforeDate = new Date(new Date(startDate.value) - (24 * 60 * 60 * 1000));
				var beforeTime = new Date(new Date(endDate.value) - (24 * 60 * 60 * 1000));

				if (data.isPlaying === false) {
					startDate.value = formatDatetime(beforeDate.getFullYear() + '-' + (beforeDate
							.getMonth() +
							1) + '-' + beforeDate.getDate() + ' ' + beforeDate.getHours() + ':' +
						beforeDate.getMinutes() + ':' + beforeDate.getSeconds());
					endDate.value = formatDatetime(beforeTime.getFullYear() + '-' + (beforeTime
						.getMonth() +
						1) + '-' + beforeTime.getDate() + ' 23:59:59')
					data.checktype = 'vehicle';
					searchLine();
				}
			};

			const afterday = () => {
				var afterDate = new Date(new Date(startDate.value).getTime() + (24 * 60 * 60 * 1000));
				var afterTime = new Date(new Date(endDate.value).getTime() + (24 * 60 * 60 * 1000));

				if (data.isPlaying === false) {
					startDate.value = formatDatetime(afterDate.getFullYear() + '-' + (afterDate
							.getMonth() +
							1) + '-' + afterDate.getDate() + ' ' + afterDate.getHours() + ':' +
						afterDate.getMinutes() + ':' + afterDate.getSeconds())
					endDate.value = formatDatetime(afterTime.getFullYear() + '-' + (afterTime
							.getMonth() + 1) +
						'-' + afterTime.getDate() + ' ' + afterTime.getHours() + ':' +
						afterTime.getMinutes() + ':' + afterTime.getSeconds());
					data.checktype = 'vehicle';
					searchLine();
				}
			};

			const fetchWeatherFromRoute = (steps) => {
				// 如果组件正在卸载，不获取天气
				if (!isComponentMounted.value) {
					return
				}

				// 取消任何现有的天气请求
				weatherRequests.value.forEach(request => {
					if (request && request.cancel) {
						request.cancel()
					}
				})
				weatherRequests.value = []

				let districtsMap = new Map()
				steps.forEach((item) => {
					item.cities && item.cities.forEach((city) => {
						city.districts.forEach((district) => {
							if (districtsMap.has(district.adcode)) {

							} else {
								districtsMap.set(district.adcode, {
									name: [city.name, district.name],
									adcode: district.adcode
								})
							}
						})
					})
				})

				let weatherRequestArray = []
				districtsMap.forEach((value, key) => {
					const request = getWeather(key)
					weatherRequests.value.push(request)
					weatherRequestArray.push(request)
				})

				axios
					.all(weatherRequestArray)
					.then(response => {
						// 检查组件是否仍然挂载后再更新
						if (!isComponentMounted.value) {
							return
						}
						let weatherString = '\n\n### 途经地天气信息\n\n'
						data.weatherArr = [];
						response.forEach((res, index) => {
							let weatherData = res.data.lives[0]

							data.weatherArr.push({
								weatherNo: `${index + 1}. ${weatherData.province}-${weatherData.city}: ${weatherData.temperature}℃ | ${weatherData.humidity}%RH, ${weatherData.weather}\n`
							})
							//weatherString = weatherString.concat(`${index + 1}. ${weatherData.province}-${weatherData.city}: ${weatherData.temperature}℃ | ${weatherData.humidity}%RH, ${weatherData.weather}\n`)
						})
						//console.log('天气:', weatherString)
						//data.contentHtml=weatherString;
						// if (activeLineObj.value) {
						//     activeLineObj.value.note = activeLineObj.value.note.concat(weatherString)
						// }
					})
					.catch(error => {
						console.log('天气请求失败:', error)
					})
			};

			const getWeather = (adcode) => {
				return axios({
					url: '/v3/weather/weatherInfo',
					params: {
						key: '401d946dc1152f0e1f110928ecc07a13',
						city: adcode
					}
				})
			};

			const siteLoadChange = (value) => {
				const selectedItem = data.siteList.find(item => item.whId === value);
				if (selectedItem) {
					data.selectedwhType = selectedItem.whType; // 更新其他参数的值。
					data.selectedwhName = selectedItem.whName;
				} else {
					data.selectedwhType = ''; // 如果没有找到匹配项，则设置为null。
					data.selectedwhName = '';
				}
			}


			return {
				...toRefs(data),
				querylorIdLine,
				queryVehiceLine,
				startPoint,
				endPoint,
				loading,
				waypoints,
				startDate,
				endDate,
				performSearch,
				addWaypoint,
				removeWaypoint,
				clearAll,
				getstartDate,
				getendDate,
				startAnimation,
				pauseAnimation,
				resumeAnimation,
				speedCountChange,
				sliderChange,
				toggleTrack,
				toggleRoad,
				toggleContent,
				searchDayCount,
				formatProgressPercentage,
				today,
				beforeday,
				afterday,
				contextMenuPositon,
				updateSitesubmit,
				siteLoadChange,
			};
		},
	});
</script>



<style scoped>
	#container {
		width: 100%;
		height: 800px;
	}

	.map-container {
		position: relative;
		width: 100%;
		height: 100%;
	}

	.search-panel {
		position: absolute;
		top: 20px;
		left: 20px;
		z-index: 100;
		width: 320px;
		background-color: white;
		border-radius: 8px;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
		padding: 20px;
	}

	.search-form h3 {
		margin: 0 0 20px 0;
		color: #333;
		font-size: 18px;
		font-weight: 600;
	}

	.form-group {
		margin-bottom: 16px;
	}

	.form-group label {
		display: block;
		margin-bottom: 6px;
		font-weight: 500;
		color: #555;
		font-size: 14px;
	}

	.waypoint-count {
		font-size: 12px;
		color: #909399;
		font-weight: normal;
	}

	.waypoints-container {
		max-height: 300px;
		padding-right: 12px;
		overflow-y: auto;
		margin-bottom: 10px;
	}

	.form-input {
		width: 100%;
		padding: 8px 12px;
		border: 1px solid #ddd;
		border-radius: 4px;
		font-size: 14px;
		transition: border-color 0.3s;
		box-sizing: border-box;
	}

	.form-input:focus {
		outline: none;
		border-color: #409eff;
	}

	.waypoint-item {
		display: flex;
		gap: 8px;
		margin-bottom: 8px;
		align-items: center;
	}

	.waypoint-input {
		flex: 1;
	}

	.btn {
		padding: 8px 16px;
		border: none;
		border-radius: 4px;
		cursor: pointer;
		font-size: 14px;
		transition: all 0.3s;
	}

	.btn:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}

	.btn-primary {
		background-color: #409eff;
		color: white;
	}

	.btn-primary:hover:not(:disabled) {
		background-color: #66b1ff;
	}

	.btn-secondary {
		background-color: #f56c6c;
		color: white;
	}

	.btn-secondary:hover {
		background-color: #f78989;
	}

	.btn-add {
		background-color: #67c23a;
		color: white;
		font-size: 12px;
		padding: 6px 12px;
	}

	.btn-add:hover {
		background-color: #85ce61;
	}

	.btn-remove {
		background-color: #f56c6c;
		color: white;
		font-size: 12px;
		padding: 6px 12px;
	}

	.btn-remove:hover {
		background-color: #f78989;
	}

	.form-actions {
		display: flex;
		gap: 10px;
		margin-top: 20px;
		margin-bottom: 20px;

		width: 100%;
		min-height: 40px;
		align-items: center;
		justify-content: flex-start;
	}

	.result-panel {
		position: absolute;
		top: 20px;
		right: 20px;
		z-index: 100;
		width: 300px;
		max-height: 400px;
		overflow-y: auto;
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		background-color: white;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		font-size: 14px;
	}

	.input-card {
		min-width: 10rem;
		top: 20px;
		left: 20px;
		bottom: auto;
	}

	.input-item {
		position: relative;
		display: -ms-flexbox;
		display: flex;
		-ms-flex-wrap: wrap;
		flex-wrap: wrap;
		-ms-flex-align: center;
		align-items: center;
		width: 100%;
		height: 3rem;
	}

	.color {
		width: 5rem;
		height: 0.6rem;
		display: inline-block;
		margin: 0 1rem;
	}

	/* ------------------------------------------*/
	.input_cell {
		width: 100%;
		height: 38px;
		display: flex;
		align-items: center;
	}

	.input_cell .label {
		width: 65px;
		text-align: left;
	}

	.input_box {
		flex: 1;
		height: 100%;
		margin-left: 10px;
		display: flex;
		align-items: center;
	}

	.bgStyle {
		background: #243290 !important;
	}


	/* ------------------------------------------------- */

	.progressDiv {
		width: 95%;
		background: url("~@/assets/images/background-trackInfo.png") no-repeat center center;
		background-size: 100% 100%;
		position: absolute;
		bottom: -100;
		left: 0;
		right: 0;
		margin: 0 auto;
		z-index: 199;
		cursor: default;
	}

	.card {
		padding: 6px 8px;
		overflow: hidden;
		background-color: white;
		backdrop-filter: blur(5px) saturate(130%);
		@include border-radius(8px);
		@include box-shadow(1px 1px 3px rgba(0, 0, 0, 0.2));
	}

	.detail {
		z-index: 999;
		backdrop-filter: blur(3px) saturate(120%);
		position: absolute;
		top: 20px;
		right: 20px;
		padding: 0 !important;
		width: 300px;

		.title {
			display: flex;
			justify-content: center;
			align-items: center;
			position: relative;
			text-align: center;
			padding: 10px 0 15px;
			font-size: 1rem;
			color: $text-main;
			border-bottom: 1px solid $border-normal;

			.title-name {
				padding: 0 5px;
				font-size: 1.5rem;
				font-weight: bold;
			}

			.video-link {
				display: block;

				&:hover {
					color: $color-main;
				}

				&:active {}
			}

			.collapse-btn {
				padding: 0 5px;
			}
		}

		&.closed {
			.title {
				padding: 5px 0 5px;
				border: none;
			}
		}

		&.center {
			left: 50%;
			transform: translateX(-50%);
		}
	}

	.content {
		padding-bottom: 20px;
		@include transition(all 0.3s);
		color: $text-subtitle;
		font-size: 0.8rem;
	}

	.info-list {
		background-color: white;
		font-size: 12px;
		padding: 10px 20px;
	}

	.info {
		width: 100%;
		line-height: 1.8;
		position: relative;
		display: flex;
		flex-flow: row nowrap;
		justify-content: space-between;

		p {
			z-index: 10;
			background-color: white;
		}

		&-title {
			padding-right: 10px;
			color: $text-main;
		}

		&-value {
			padding-left: 10px;
		}

		&::after {
			width: 100%;
			height: 1px;
			position: absolute;
			bottom: 50%;
			left: 0;
			content: '';
			border-bottom: 1px dashed #dddddd;
			/* 应该设置底部边框 */
		}
	}

	.note {
		overflow-y: auto;
		padding: 10px 20px;
		border-top: 1px solid $border-normal;
		line-height: 1.5;
		color: $text-main;
	}

	.bgBlock {
		position: absolute;
		width: 100%;
		height: 100%;
		background: #fff;
		z-index: 9999999;
		background: rgba(255, 255, 255, 0.6);
		left: 0;
		top: 0;
	}

	.load {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		z-index: 999;
		text-align: center;
		padding: 10px 50px;
	}

	/* ---------------------------------------------------------------------------------------------------------- */
	.info-box {
		gap: 10px;
		margin-top: 20px;
		margin-bottom: 20px;

		width: 100%;
		min-height: 40px;
		align-items: center;
		justify-content: flex-start;
	}

	.info-box .info-row {
		width: 100%;
		min-height: 35px;

		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

	.info-box .operation-row {
		width: 100%;
		min-height: 40px;

		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

	.info-box label {
		display: inline-block;
		width: 75px;
		text-align: right;
		margin-right: 5px;
	}

	.info-box .operation-row input[type="text"] {
		width: calc(100% - 85px);
		height: 30px;

		padding: 0 5px;
		border: 1px solid #e5e5e5;
		border-radius: 5px;
		font-size: 14px;
	}

	.info-box .operation-row input[type="text"]:focus {
		outline: none;
	}

	.info-box .operation-row span.btn {
		padding: 5px 10px;
		border-radius: 5px;
		color: #ffffff;

		font-size: 13px;
		cursor: pointer;
	}


	.info-box .operation-row select#stopTime,
	.info-box .operation-row select#trackType {
		width: 80px;
		height: 30px;

		padding: 0 5px;
		border: 1px solid #e5e5e5;
		border-radius: 5px;
		font-size: 14px;
		cursor: pointer;
	}

	.info-box .operation-row select#trackType {
		width: 100px;
		height: 30px;

		padding: 0 5px;
		border: 1px solid #e5e5e5;
		border-radius: 5px;
		font-size: 14px;
		cursor: pointer;
	}

	.info-box .operation-row .buttonGroup {
		width: calc(100% - 85px);
		height: 100%;

		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.info-box .operation-row .buttonGroup span.btn {
		padding: 5px 10px;
		border: 1px solid #e5e5e5;
		border-radius: 5px;
		color: #666666;
		background: transparent;

		font-size: 13px;
		cursor: pointer;
	}

	.info-box .operation-row .buttonGroup span.btn:hover {
		background: #243290;
		color: #ffffff;
	}

	.info-box .operation-row span#queryLine {
		width: 100%;
		text-align: center;
	}


	.info-box .operation-row img {
		margin-right: 10px;
		cursor: pointer;
		vertical-align: middle;
	}

	.info-box .operation-row input[type=range] {
		width: 42%;
		-webkit-appearance: none;
		border-radius: 10px;
		background: -webkit-linear-gradient(#243290, #243290) no-repeat;
		background-size: 0 100%;
		vertical-align: middle;
	}

	.info-box .operation-row input[type=range]:focus {
		outline: none;
	}

	.info-box .operation-row input[type=range]::-moz-range-thumb {
		-webkit-appearance: none;
		margin-top: -3px;
		background: #ffffff;
		border-radius: 50%;
		border: 0.4em solid #243290;
		box-shadow: 0 .125em .125em #3b4547;
		cursor: pointer;
	}

	.info-box .operation-row input[type=range]::-moz-range-track {
		height: 15px;
		border-radius: 8px;
		border: 1px solid #e5e5e5;
		/*background: #4D4D4D;*/
	}

	.info-box .operation-row input[type=range]::-webkit-slider-thumb {
		-webkit-appearance: none;
		height: 20px;
		width: 20px;
		margin-top: -3px;
		background: #ffffff;
		border-radius: 50%;
		border: 0.4em solid #243290;
		box-shadow: 0 .125em .125em #3b4547;
		cursor: pointer;
	}

	.info-box .operation-row input[type=range]::-webkit-slider-runnable-track {
		height: 15px;
		border-radius: 8px;
		border: 1px solid #e5e5e5;
		/*background: #4D4D4D;*/
	}

	.info-box .operation-row #collapse {
		line-height: normal;
		margin-left: 10px;

		display: flex;
		align-items: center;
		justify-content: center;
	}

	.info-box .operation-row #collapse img {
		background: white;
		border-radius: 50%;
		margin: 0 0 0 3px;
		width: 18px;
	}

	.markdown {
		line-height: 1.6;
		color: $text-main;
		font-size: 12px;

		hr {
			height: 1px;
			background-color: $border-normal;
			width: 100%;
			margin: 20px 0;
		}

		h3 {
			margin-top: 20px;
			margin-bottom: 8px;
			font-size: 18px
		}

		p {
			line-height: 1.5;
			margin-bottom: 5px;
		}

		img {
			border: 1px solid $border-normal;
			max-width: 100%;
			background-color: white;
			@include border-radius(3px);
		}


		pre {
			margin-bottom: $gap;
			font-size: $fz-small;
			padding: $gap $gap + 5;
			background-color: $bg-active;

			code {
				padding: 0;
				background-color: $bg-active;
			}
		}

		code {
			padding: 2px 5px;
			font-size: 13.5px;
			color: #333;
			background-color: $bg-active;
			@include border-radius(2px);
		}

		table {
			margin-bottom: $gap;
			border: 1px solid $border-normal;

			tr {
				th {
					text-align: left;
					min-width: 50px;
					padding: 4px 10px;
					border: 1px solid $border-normal;
					background-color: $bg-active;

					&[align=left] {
						text-align: left;
					}

					&[align=right] {
						text-align: right;
					}

					&[align=center] {
						text-align: center;
					}
				}

				td {
					text-align: left;
					border: 1px solid $border-normal;
					padding: 3px 10px;

					&[align=left] {
						text-align: left;
					}

					&[align=right] {
						text-align: right;
					}

					&[align=center] {
						text-align: center;
					}
				}
			}
		}

		input[type=checkbox] {
			display: inline-block;
			-webkit-appearance: checkbox !important;
		}

		ol,
		ul {
			margin-left: $gap;
			margin-bottom: $gap;

			li {
				margin-left: 20px;
				line-height: 1.5;
				margin-bottom: 2px;
			}
		}

		blockquote {
			margin-top: 15px;
			margin-bottom: 15px;
			padding-top: 10px;
			padding-bottom: 10px;
			border-left: 3px solid transparentize(black, 0.8);
			padding-left: 18px;
			background-color: #f5f5f5;

			>*:last-child {
				margin-bottom: 0;
			}
		}

		a {
			color: $orange;
			text-decoration: underline;
		}
	}

	.btn-outline1 {
		background: #ff6600 !important;
	}

	.btn-outline2 {
		background: #2eb779 !important;
	}

	.btn_warp {
		width: 100%;
		height: 80px;
		display: flex;
		justify-content: center;
		align-content: center;
	}

	.btn_warp>div {
		width: 90px;
		height: 36px;
		border-radius: 6px;
		font-size: 14px;
		color: #ffffff;
		cursor: pointer;
		text-align: center;
		line-height: 36px;
		margin-left: 20px;
	}

	.mar-bot-20 {
		margin-bottom: 20px !important;
	}


	/* ---------------------------------------------------------------------------------------------------------- */
</style>